var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"app-container full-height"},[(!_vm.hideDashboardNav)?_c('DashboardNav'):_vm._e(),_c('div',{staticClass:"body-container",class:{
          'hidden-dashboard-nav': _vm.hideDashboardNav,
          'minimized-nav': _vm.isDashboardNavMinimized,
          'logged-in': _vm.isLoggedIn,
          accountProfilePage: _vm.accountProfilePage,
          isDarkMode: _vm.isDarkMode,
        }},[(_vm.showNavBar)?_c('NavBar',{attrs:{"is-mobile":_vm.isMobile}}):_vm._e(),(_vm.isLoggedIn)?_c('Notifications',{attrs:{"is-mobile":_vm.isMobile}}):_vm._e(),_c('router-view',{attrs:{"is-mobile":_vm.isMobile}})],1)],1)]),_c('SnackBar'),_c('IframeAuth')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }